import { immerable } from "immer";

export class SpendCategory {
    [immerable] = true;

    public readonly name: string;
    public readonly id: number;
    private _isSelected: boolean;

    constructor(
        name: string,
        id: number,
        isSelected: boolean
    ) {
        this.name = name;
        this.id = id;
        this._isSelected = isSelected;
    }

    isSelected() {
        return this._isSelected;
    }

    setIsSelected(isSelected: boolean) {
        this._isSelected = isSelected;
    }

    toggleIsSelected() {
        this._isSelected = !this._isSelected;
    }
}
